module.exports = __webpack_public_path__ + "img/leaves.23525421.png";